import { STORAGE_COMPONENT_IDS } from '../../componentIds';
export class ProductInfoComponent {
    static id = STORAGE_COMPONENT_IDS.ProductInfoComponent;
    typeId = ProductInfoComponent.id;
    doStoreInSnapshot = true;
    serializable = false;
    globalArticleNbr;
    productType;
    design;
    tags;
    constructor(globalArticleNbr, productType, design, tags = []) {
        this.globalArticleNbr = globalArticleNbr;
        this.productType = productType;
        this.design = design;
        this.tags = [...tags];
    }
    eq(other) {
        return (this.globalArticleNbr === other.globalArticleNbr &&
            this.productType === other.productType &&
            this.design === other.design);
    }
}
//# sourceMappingURL=ProductInfoComponent.js.map